import React, { FC, useState } from "react";
import Button from "@material-ui/core/Button";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import { DeleteFavouriteDialog } from "../../DeleteFavouriteDialog";

import { useStyles } from "./FavouritesSettingsActions.styles";
import { messages } from "./FavouritesSettingsActions.messages";
import { IFavouritesSettingsActionsProps } from "./FavouritesSettingsActions.types";
import { FavouriteItemType } from "../../../types";

export const FavouritesSettingsActions: FC<IFavouritesSettingsActionsProps> = (props) => {
  const { onDelete, onCancel, onSave, isChanged, savedFavouriteItem } = props;
  const classes = useStyles();
  const isHideSaveCancel = !(savedFavouriteItem?.type === FavouriteItemType.SavedBulkExport);
 
  const [deleteFavouriteDialogOpen, setDeleteFavouriteDialog] = useState(false);
  return (
    <div className={classes.root}>
      {onSave && isHideSaveCancel && (
        <Button onClick={onSave} disabled={!isChanged} color="primary" variant="contained" classes={{ root: classes.button }}>
          <FormattedMessage {...messages.save} />
        </Button>
      )}
      {onCancel && isHideSaveCancel && (
        <Button
          onClick={onCancel}
          disabled={!isChanged}
          color="primary"
          variant="contained"
          classes={{ root: cn(classes.button, classes.cancelButton) }}
        >
          <FormattedMessage {...messages.cancel} />
        </Button>
      )}
      <Button
        onClick={() => setDeleteFavouriteDialog(true)}
        disabled={!savedFavouriteItem}
        color="primary"
        variant="contained"
        classes={{ root: cn(classes.button, classes.deleteButton) }}
      >
        <FormattedMessage {...messages.delete} />
      </Button>

      {savedFavouriteItem && (
        <DeleteFavouriteDialog
          favouriteItemName={savedFavouriteItem.name}
          onDelete={() => {
            setDeleteFavouriteDialog(false);
            onDelete();
          }}
          open={deleteFavouriteDialogOpen}
          handleCloseDialog={() => setDeleteFavouriteDialog(false)}
        />
      )}
    </div>
  );
};
